export default "__VITE_ASSET__C9MF6Zxe__"